import classNames from 'classnames';
import { EventStatus } from 'components/eventItemStatus/EventItemStatus';

export interface ArrivalBadgeProps {
  arrivalTime: string;
  status: EventStatus;
}

const ArrivalTimePill = ({ arrivalTime, status }: ArrivalBadgeProps) => (
  <span
    className={classNames(
      'z-10 block rounded-sm pt-2 pr-3 pb-2  text-sm font-bold text-white before:absolute before:top-2 before:left-3',
      {
        ' relative w-fit bg-design-green pl-7 before:content-onTimeEventLight dark:bg-design-black dark:text-design-green dark:before:content-onTimeEvent':
          status === EventStatus.OnTime,
      },
      {
        ' absolute left-0 top-full mt-1 w-fit bg-design-red pl-7 before:content-lateEvent 2xl:left-auto 2xl:top-0 2xl:mt-0 2xl:-right-32':
          status === EventStatus.Late,
      },
      {
        ' absolute left-0 top-full mt-1 w-fit bg-yellow pl-3 text-design-black 2xl:left-auto 2xl:top-0 2xl:mt-0 2xl:-right-28':
          status === EventStatus.Cancelled,
      },
    )}
  >
    {arrivalTime}
  </span>
);

export default ArrivalTimePill;
